module.exports = __webpack_public_path__ + "static/media/work_with_a_coach.c7357f09.png";